<template>
  <b-form-group v-if="content.show_field">
    <label for="multiselect_name">{{ content.key | capitalize }}</label>
    <sup v-if="content.required" class="text-danger required-css">
      <i class="fa fa-asterisk"></i>
    </sup>
    <span v-if="isEdited()" class="badge badge-edited"><i class="fa fa-check" aria-hidden="true"></i> Edited</span>
    <div :id="this.content.path">
      <multiselect id="multiselect_name"
                   class="custom-multiselect"
                   :value="selectedValues"
                   track-by="text"
                   label="text"
                   open-direction="bottom"
                   :multiple="true"
                   :close-on-select="false"
                   :options="optionsForSelect"
                   @open="inputFocused()"
                   @remove="optionRemoved($event)"
                   @select="optionAdded($event)"></multiselect>
    </div>
    <div v-if="isEdited()">
      <b-tooltip :target="this.content.path" placement="topright">
        <strong>Original Option</strong>
        <div v-if="orgSelectedOptions.length > 0">
          {{ orgSelectedOptionsText() }}
        </div>
        <div v-else>
          N/A
        </div>
      </b-tooltip>
    </div>
    <b-popover :target="this.content.path" triggers="focus" placement="top" variant="danger" boundary="window">
       <div class="canvas-wrapper">
        <canvas :id="'canvas_' + this.content.path"></canvas>
      </div>
    </b-popover>
  </b-form-group>
</template>

<script>
import _ from 'lodash'
import Multiselect from 'vue-multiselect'

export default {
  props: ['content', 'imgBase', 'imgUrl'],
  name: 'process-multi-select-data',
  components: { Multiselect },
  computed: {
    selectedValues: function () {
      let items = this.content.children
      if (items[0].pv_id === null) {
        _.each(items, function (item) {
          _.each(item.children, function (i) {
            if (i.data_type === 'checkbox') {
              item.current_value = i.current_value
            }
            if (item.data_type === 'checkbox_text' && i.data_type !== 'checkbox') {
              if (i.current_value !== '') {
                item.key = i.current_value.trim()
              }
            }
          })
        })
      }
      let selected = _.filter(items, function (c) { return c.current_value === 'true' })
      return _.map(selected, function (opt) { return { tm_id: opt.tm_id, id: opt.pv_id, text: opt.key } })
    },
    optionsForSelect: function () {
      return _.map(this.content.children, function (c) { return { tm_id: c.tm_id, id: c.pv_id, text: c.key } })
    },
    orgSelectedOptions: function () {
      return _.filter(this.content.children, function (c) { return c.original_value === 'true' })
    }
  },
  methods: {
    isEdited: function () {
      let items = this.content.children
      if (items[0].pv_id === null) {
        _.each(items, function (item) {
          _.each(item.children, function (i) {
            if (i.data_type === 'checkbox') {
              item.original_value = i.original_value
            }
          })
        })
      }
      let ocrSelectedOptions = _.filter(items, function (c) { return c.original_value === 'true' })
      let userSelectedOptions = _.filter(items, function (c) { return c.current_value === 'true' })
      let ocredIds = _.map(ocrSelectedOptions, 'tm_id').sort()
      let selectedIds = _.map(userSelectedOptions, 'tm_id').sort()
      return !_.isEqual(ocredIds, selectedIds)
    },
    orgSelectedOptionsText: function () {
      return _.map(this.orgSelectedOptions, 'key').join(', ')
    },
    optionRemoved: function (option) {
      let removedElement = _.find(this.content.children, function (el) { return el.tm_id === option.tm_id })
      if (removedElement.pv_id === null) {
        _.each(removedElement.children, function (el) {
          if (el.data_type === 'checkbox') {
            el.current_value = 'false'
          }
        })
      }
      removedElement.current_value = 'false'
      if (removedElement.pv_id === null) {
        let checkboxItems = _.filter(removedElement.children, function (c) { return c.data_type === 'checkbox' })
        let items = _.map(checkboxItems, function (c) { return { id: c.pv_id, current_value: 'false' } })
        this.$emit('dataUpdate', items)
      } else {
        this.$emit('dataUpdate', [{id: option.id, current_value: 'false'}])
      }
    },
    optionAdded: function (selected) {
      let addedElement = _.find(this.content.children, function (el) { return el.tm_id === selected.tm_id })
      if (addedElement.pv_id === null) {
        _.each(addedElement.children, function (el) {
          if (el.data_type === 'checkbox') {
            el.current_value = 'true'
          }
        })
      }
      addedElement.current_value = 'true'
      if (addedElement.pv_id === null) {
        let checkboxItems = _.filter(addedElement.children, function (c) { return c.data_type === 'checkbox' })
        let items = _.map(checkboxItems, function (c) { return { id: c.pv_id, current_value: 'true' } })
        this.$emit('dataUpdate', items)
      } else {
        this.$emit('dataUpdate', [{id: selected.id, current_value: 'true'}])
      }
    },
    showFieldCanvas: function (imageBase, imageUrl, path) {
      let { x_pos: x, y_pos: y, width, height } = this.content
      var canvas = document.getElementById('canvas_' + path)
      if (height / 50 > 4) {
        canvas.parentElement.style.maxHeight = '100px'
        canvas.style.maxHeight = height / 4 + 'px'
      } else {
        canvas.parentElement.style.maxHeight = '75px'
        canvas.style.maxHeight = '50px'
      }
      canvas.width = width
      canvas.height = height
      var image = new window.Image()
      image.src = imageBase + imageUrl
      var ctx = canvas.getContext('2d')
      image.onload = function () {
        ctx.drawImage(image, x, y, width, height, 0, 0, width, height)
      }
    },
    inputFocused: function () {
      // document.activeElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
      this.$emit('focused', this.content.path)
      this.showFieldCanvas(this.imgBase, this.imgUrl, this.content.path)
    }
  }
}
</script>

<style lang="scss" scoped>
.canvas-wrapper {
  max-width: 200px;
  padding: 5px;
  overflow: auto;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgb(183, 184, 185);
    -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
}
/deep/ .custom-multiselect .multiselect__content-wrapper {
  box-shadow: 0px 15px 15px rgba(0, 0, 0, 0.35) !important;
  border: 2px solid #e8e8e8;
  border-width: 1px 2px 3px 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/process/processMultiSelectData.vue